import { Household } from "@/types/types";
import { useEffect } from "react";
import { LTIPDataAwareResponse } from "./useLTIP";
import { useLocalStorage } from "./useLocalStorage";

const useDefaultSelectedClient = (
  household: Partial<Household> | undefined,
  data: LTIPDataAwareResponse | undefined,
  selectedClient: string | null | undefined,
  setSelectedClient: (client: string | null | undefined) => void,
  lsKey: string
) => {
  const { saveData } = useLocalStorage();
  useEffect(() => {
    if (household?.isSingle || !household?.externalCode || !data) return;

    if (
      !data?.primaryClientHasData &&
      data?.secondaryClientHasData &&
      selectedClient === household?.primaryContact?.externalCode
    ) {
      setSelectedClient(household?.secondaryContact?.externalCode);
      saveData(
        `${lsKey}-client-${household?.externalCode}-${household?.clientCode}`,
        household?.secondaryContact?.externalCode as string
      );
    } else if (
      !data?.secondaryClientHasData &&
      data?.primaryClientHasData &&
      selectedClient === household?.secondaryContact?.externalCode
    ) {
      setSelectedClient(household?.primaryContact?.externalCode);
      saveData(
        `${lsKey}-client-${household?.externalCode}-${household?.clientCode}`,
        household?.primaryContact?.externalCode as string
      );
    } else return;
  }, [
    household?.isSingle,
    household?.primaryContact?.externalCode,
    household?.secondaryContact?.externalCode,
    selectedClient,
    setSelectedClient,
    data?.bothClientsHaveData,
    data?.primaryClientHasData,
    data?.secondaryClientHasData,
    data,
    household?.externalCode,
    saveData,
    lsKey,
  ]);
};

export default useDefaultSelectedClient;
